import React from "react";
import Box from "../../Interface/Box";
import {useEthereum} from "../../../EthereumContext";
import Separator from "../../Interface/Separator/Separator";
import Proposal from "../Proposal/Proposal";
import {useDispatch, useSelector} from "react-redux";
import {fetchBlockNumber, fetchProposals} from "../../../redux/governor";
import BigNumber from "bignumber.js";
import Button from "../../Interface/Button/Button";
import {Link} from "react-router-dom";
import './style.scss';

function Proposals() {
    const {governor, provider} = useEthereum();
    const {proposals, blockNumber} = useSelector(store => store.governor);
    const userVotes = useSelector(store => store.govToken.userVotes);
    const dispatch = useDispatch();

    React.useEffect(() => dispatch(fetchBlockNumber({provider})), [provider, dispatch]);
    React.useEffect(
        () => dispatch(fetchProposals({governor, blockNumber})),
        [governor, blockNumber, dispatch]
    );

    let openProposals = [], pastProposals = [];
    if (blockNumber) {
        openProposals = Object.values(proposals).sort((a, b) => b.id - a.id).filter(p => p.endBlock > blockNumber);
        pastProposals = Object.values(proposals).sort((a, b) => b.id - a.id).filter(p => p.endBlock <= blockNumber);
    }

    const canCreateProposal = (new BigNumber(userVotes)).gte(process.env.PROPOSAL_THRESHOLD ?? (new BigNumber(10)).pow(23));

    return (
        <React.Fragment>
            <div className="proposals">
                <Box className="proposals-wrapper" direction="column" align="flex-start">
                    <span className="proposals-title">Open Proposals</span>
                    <Separator />
                    {canCreateProposal && (
                        <React.Fragment>
                            <div className="proposals-create">
                                <span style={{color: "var(--grey1)"}}>You can create Proposal</span>
                                <Link to="/proposal">
                                    <Button>Create Proposal</Button>
                                </Link>
                            </div>
                            <Separator />
                        </React.Fragment>
                    )}
                    {openProposals.map((p, index) => (
                        <Proposal
                            key={p.id}
                            proposal={p}
                            open
                            isLast={index === openProposals.length - 1}
                            block={blockNumber}
                        />
                    ))}
                </Box>
            </div>
            <div className="proposals">
                <Box className="proposals-wrapper" direction="column" align="flex-start">
                    <span>Past Proposals</span>
                    <Separator />
                    {pastProposals.map((p, index) => (
                        <Proposal
                            key={p.id}
                            proposal={p}
                            isLast={index === pastProposals.length - 1}
                            block={blockNumber}
                        />
                    ))}
                </Box>
            </div>
        </React.Fragment>
    );
}

export default Proposals;
